

angular.module('theme')

.run(function($themeInitialSettings) {

    $themeInitialSettings['topNavThemeClass'] = 'navbar-default';
    $themeInitialSettings['sidebarThemeClass'] = 'sidebar-midnightblue';

})
